<template>
  <button @click="setChatbot(!isChatbotOpen)" :class="{ shadow: !isChatbotOpen }">
    <svg width="88" height="88" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g v-show="!isChatbotOpen" opacity="0.45">
        <circle cx="44" cy="44" r="28" fill="#EE3326">
          <animate attributeName="r" values="28; 44; 44" keyTimes="0; 0.5; 1" dur="3s" repeatCount="indefinite" />
          <animate attributeName="opacity" values="0.2; 1; 0" keyTimes="0; 0.1; 1" dur="3s" repeatCount="indefinite" />
        </circle>
      </g>
      <g v-show="!isChatbotOpen" opacity="0.45">
        <circle cx="44" cy="44" r="0" fill="#EE3326">
          <animate attributeName="r" values="28; 44; 44" keyTimes="0; 0.5; 1" begin="1.5s" dur="3s"
            repeatCount="indefinite" />
          <animate attributeName="opacity" values="0.2; 1; 0" keyTimes="0; 0.1; 1" begin="1.5s" dur="3s"
            repeatCount="indefinite" />
        </circle>
      </g>
    </svg>
    <svg :width="config.icon_dimensions.width" :height="config.icon_dimensions.height" class="icon">
      <use :xlink:href="iconPath"></use>
    </svg>
  </button>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';

export default {
  methods: {
    ...mapActions('search', ['setChatbot']),
  },
  computed: {
    ...mapGetters('config', ['features']),
    ...mapState('search', ['isChatbotOpen']),

    config() {
      return this.features.chatbot || {};
    },

    iconPath() {
      return '/icons/ai-icon.svg#' + this.config.icon;
    }
  }
}
</script>

<style scoped lang="scss">
button {
  background: none;
  padding: 0;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  outline: none;
  position: relative;
  width: 88px;
  height: 88px;

  &.shadow {
    box-shadow: 0px 0px 30px 20px rgba(0, 0, 0, 0.25);
    background: rgba(0, 0, 0, 0.25);
  }
  
  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>